import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

export function runApp() {
  const context = {
    config: getConfig(),
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
  };

  const store = createApplicationState(context);

  renderApplication({ context, store });
}
